"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TeamServiceAreaEntity_1 = __importDefault(require("./Entity/TeamServiceAreaEntity"));
var TeamServiceAreaApi = /** @class */ (function () {
    function TeamServiceAreaApi(session) {
        this.teamServiceAreaEntity = new TeamServiceAreaEntity_1.default(session);
    }
    TeamServiceAreaApi.prototype.getAll = function () {
        return this.teamServiceAreaEntity.service.getAll();
    };
    TeamServiceAreaApi.prototype.updateAll = function (request) {
        return this.teamServiceAreaEntity.updateAll(request);
    };
    return TeamServiceAreaApi;
}());
exports.default = TeamServiceAreaApi;
//# sourceMappingURL=TeamServiceAreaApi.js.map